// extracted by mini-css-extract-plugin
export default {"root":"zi7u4T","physicalLayout":"Et46Sx","logicalLayout":"bpSNnr","rootDirection":"Trmtvb","container":"qi0bcm"};